// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_50 } from '@/lib/gridElements/size';
import { PINTEREST } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const clicksHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.pinterest.clicks_history',
    tooltip: 'chart.pinterest.tooltip_clicks_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.pinterest.clicks_history_name',
        avg: 'chart.pinterest.clicks_history_avg'
    },
    id: 'clicks_history',
    social: PINTEREST,
    color: {
        value: 'blue',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.pinterest.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
